import { PostsList } from './Posts';

export default function Pages(): JSX.Element {
  return <PostsList type="page" title="Pages" />;
}
